import React, { useEffect, useState } from "react";
import { Avatar } from "@mui/material";
import { createAvatar } from "@dicebear/core";
import * as collection from "@dicebear/collection";

const UserAvatar = ({ userId, avatarUrl, size = 30, radius = 40 }) => {
  const [svgString, setSvgString] = useState(null);

  useEffect(() => {
    if (!avatarUrl && userId) {
      const avatar = createAvatar(collection.identicon, {
        seed: userId || "12345",
        size,
        radius,
      });
      const svg = avatar.toString();
      setSvgString(`data:image/svg+xml;utf8,${encodeURIComponent(svg)}`);
    } else {
      setSvgString(null);
    }
  }, [userId, avatarUrl, size, radius]);

  return (
    <Avatar
      src={avatarUrl || svgString || undefined}
      sx={{
        width: "2.5rem",
        height: "2.5rem",
        bgcolor: "grey.200",
      }}
    />
  );
};

export default UserAvatar;
